module.exports = __webpack_public_path__ + "img/load.7acbc2be.svg";